import controller from './controller';
import template from './template.html';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	// $urlRouterProvider.when('/main/panel/:id', '/main/panel/areas');

	$stateProvider.state('main.panel', {
		url: '/panel/:id',
		abstract:true,
		controllerAs: 'ctrl',
		template: '<ui-view/>',
		resolve: {
			panel: [
				'$stateParams', '$q', 'ApiPanelsService',
				($stateParams, $q, ApiPanelsService, )=>{

					let deferred = $q.defer();

					ApiPanelsService.getPanelById($stateParams.id).then((result)=>{
						let panel = result.data;

						deferred.resolve(panel);
					});
					
					return deferred.promise;
				}
			]
		}
	})
	.state('main.panel.control', {
		url: '',
		controllerAs: 'ctrl',
		controller: controller,
		template: template,
	});

}



/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/routes.js
 **/